module.exports = __webpack_public_path__ + "static/media/39.77c5fdb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/39.jpg
// module id = 299
// module chunks = 0